export default __webpack_public_path__ + "static/media/bgHead.dcb4422c.png";